import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      // Always strip the (single-use) session_id from the URL FIRST so a refresh
      // after a network glitch won't replay an already-consumed session.
      window.history.replaceState(null, "", "/dashboard");
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "No se pudo iniciar sesión. Inténtalo de nuevo.";
        navigate("/login?error=" + encodeURIComponent(msg), { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="font-mono text-sm text-zinc-500">Autenticando…</p>
    </div>
  );
}
